import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Button } from '@mdvip/shared/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@mdvip/shared/components/ui/card';
import { useTranslation } from 'react-i18next';

import { useOpenChlSession } from '@/hooks/useOpenChlSession';

export function ClevelandHeartLab() {
  const { t } = useTranslation('providers');
  const { open: openChlSession, isPending } = useOpenChlSession();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <Card className="hover:shadow-md transition-shadow">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm">{t('resources.clevelandHeartLab.chlTestResults')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <CardDescription className="text-xs">
            {t('resources.clevelandHeartLab.chlTestResultsDescription')}
          </CardDescription>
          <Button
            variant="default"
            size="sm"
            className="w-full text-xs"
            disabled={isPending}
            onClick={() => openChlSession()}
          >
            <Icon name="externalLink" size="xs" className="mr-2" />
            {t('resources.clevelandHeartLab.openTestResults')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
